import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input from 'material-ui/Input';


class Start extends Component {
  render(){
    const { classes, theme, location } = this.props;

    return(
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          To create a saved search we offer 6 different filters. Go through the following one by one.
        </Typography>
        <div>
          <Button onClick={() => {this.props.changeRoute("/console/search/create_new_search/six_basic_filters/question1");}} className={classes.button} raised color="primary">
            1. Distance
          </Button>
        </div>
        <div>
        <Button onClick={() => {this.props.changeRoute("/console/search/create_new_search/six_basic_filters/question2");}} className={classes.button} raised color="primary">
          2. OAR Range
        </Button>
      </div>
      <div>
        <Button onClick={() => {this.props.changeRoute("/console/search/create_new_search/six_basic_filters/question3");}} className={classes.button} raised color="primary">
          3. Profile Age
        </Button>
      </div>
      <div>
        <Button onClick={() => {this.props.changeRoute("/console/search/create_new_search/six_basic_filters/question4");}} className={classes.button} raised color="primary">
          4. Oldest Preferred Age
        </Button>
      </div>
      <div>
        <Button onClick={() => {this.props.changeRoute("/console/search/create_new_search/six_basic_filters/question5");}} className={classes.button} raised color="primary">
          5. Education
        </Button>
      </div>
      <div>
        <Button onClick={() => {this.props.changeRoute("/console/search/create_new_search/six_basic_filters/question6");}} className={classes.button} raised color="primary">
          6. Income Range
        </Button>
      </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Start)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Start/index.js